export default __webpack_public_path__ + "static/5-5efc073317a0d10b5097da95b8ddf49a.png";